import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import PrivilegeCodeForm from './PrivilegeCodeForm/PrivilegeCodeForm';
import PrivilegeGiftForm from './PrivilegeGiftForm/PrivilegeGiftForm';
import MinusCircleIcon from 'components/Common/Icons/MinusCircle';
import PlusCircleIcon from 'components/Common/Icons/PlusCircle';
import GreenTickIcon from 'components/Common/Icons/GreenTick';
import Button from 'components/UI/Buttons/Button/Button';
import { cartContext } from 'contexts/cartContext';

import styles from './PrivilegeCode.module.scss';

export default function PrivilegeCode(): JSX.Element {
  const { t } = useTranslation('translation');
  const { privilegeCode, cart } = useContext(cartContext);
  const { privilegeCodeAdvantages, giftsChoice } = { ...cart };
  const [extend, setExtend] = useState(false);

  return (
    <div className={styles.container}>
      <p className={styles.title}>
        {t('PRIVILEGE_CODE_APPLIED', { code: privilegeCode })}
        <GreenTickIcon className={styles.tick} />
      </p>
      {privilegeCodeAdvantages && (
        <div
          className={classNames(styles.message, {
            [styles.extend]: extend,
          })}
        >
          <div
            className={styles.content}
            dangerouslySetInnerHTML={{
              __html: privilegeCodeAdvantages,
            }}
          />
          <div className={styles.buttonWrapper}>
            <Button
              className={styles.toggleContent}
              onClick={() => setExtend(prev => !prev)}
            >
              <PlusCircleIcon className={styles.plusIcon} />
              <MinusCircleIcon className={styles.minusIcon} />
            </Button>
          </div>
        </div>
      )}
      <PrivilegeCodeForm />
      {!!giftsChoice?.length && <PrivilegeGiftForm gifts={giftsChoice} />}
    </div>
  );
}
